
import { values } from 'lodash';

import { loadWidget } from '../utils/load-widget';
import { getEvents } from '../../utils/api';

const bookButtonText = 'Buy Tickets';
const now = new Date();

loadWidget('booking-links', {
    props: ['productionNo', 'perfNo'],
    data: function () {
        return {
            ViewModel: {
                Favorites: {
                    ProdSeasonNo: null,
                    PerfNo: null,
                },
                Subscribe: false,
                Booking: false,
                Loading: true,
                Custom: false,
            }
        }
    },
    methods: {
        init() {
            const productionNo = parseInt(this.$props.productionNo, 10);
            const perfNo = parseInt(this.$props.perfNo, 10);

            if (productionNo) {
                this.ViewModel.Favorites.ProdSeasonNo = productionNo;
            }

            if (perfNo) {
                this.ViewModel.Favorites.PerfNo = perfNo;
            }

            if (!productionNo && !perfNo) {
                this.ViewModel.Loading = false;
            } else {
                getEvents().then(data => {
                    if (perfNo) {
                        this.ViewModel.Performances = data.filter(perf => perf.perf_no === perfNo);
                    } else {
                        this.ViewModel.Performances = data.filter(perf => perf.prod_season_no === productionNo);
                    }

                    const onsalePerfs = this.ViewModel.Performances.filter(perf => {
                        const onSaleDate = new Date(perf.on_sale_date);
                        const offSaleDate = new Date(perf.off_sale_date);
                        return (onSaleDate <= now && offSaleDate > now);
                    });

                    const onsalePerfsWithAvailability = onsalePerfs.filter(perf => {
                        return values(perf.prices).filter(price => {
                            return price.available === 'Y' && parseInt(price.avail_count, 10) > 0;
                        }).length > 0;
                    });

                    if (this.ViewModel.Performances.length) {
                        const subscriptionDetails = this.ViewModel.Performances[0].subscription;
                        if (subscriptionDetails) {
                            this.ViewModel.Subscribe = {
                                Link: subscriptionDetails.link,
                                Text: subscriptionDetails.title,
                            };
                        }
                    }

                    if (onsalePerfs.length) {
                        this.ViewModel.Booking = {
                            Text: onsalePerfsWithAvailability.length > 0 ? bookButtonText : false,
                        };
                        if (onsalePerfs.length === 1) {
                            this.ViewModel.Booking.Link = onsalePerfs[0].perf_book_url;
                        } else {
                            this.ViewModel.Booking.Link = onsalePerfs[0].prod_book_url;
                        }
                    }

                    if (this.ViewModel.Performances[0].custom_booking.status && this.ViewModel.Performances[0].custom_booking.url) {
                        this.ViewModel.Custom = this.ViewModel.Performances[0].custom_booking;
                    }

                })
                .finally(() => {
                    this.ViewModel.Loading = false;
                });
            }
        },
    },
    beforeMount() {
        this.init();
    }
});
